import { ErrorBag } from 'vee-validate';

export default {
    methods: {
        processLaravelErrors($validator, response) {
            let errors = $validator.errors;

            if (errors !== undefined) {
                $validator.errors.clear();
            }

            if (response.status === 422) {
                let laravelErrors = response.data.errors;
                let errorBag = new ErrorBag();

                Object.keys(laravelErrors).forEach(function(k, i) {
                    Array.from(laravelErrors[k]).forEach(function(v) {
                        errorBag.add(k, v);
                    });
                });

                $validator.errors = errorBag;
            }
        },

        hasLaravelErrors(error) {
            if (_.isNil(error.response)) return false;
            if (error.response.status === 422) return true;

            return false;
        },
    },
};
